const d3 = require('d3')
const moment = require('moment');
const { parseDate } = require('../utils/formatters.js');
const { wrap } = require( '../utils/shared-functions.js');

const DEVICE_COLOR = '#6DA758';
const MANUAL_COLOR = '#558AC2';
const EXTERNALL_COLOR = '#CF42F0';
const EMPTY_COLOR = '#000000';
const NORMAL_OXYGEN_COLOR = '#EDF3DD';
const LOW_OXYGEN_COLOR = '#FBE0D5';
const MAX_SPO2_percent = 100;
const MIN_SPO2_percent = 70;
const margin = { top: 40, right: 30, bottom: 40, left: 50 };

exports.createSpO2Chart = function (rawData, manualData, externalData,thresholds,onClick,width,height,thresholdsStatus) {

  const { SpO2: spo2_threshold } = thresholds;

  const data = rawData.map((d, i) => {
      const date = parseDate(moment(d['date']).format('YYYY-MM-DD'));
      const { high: high_man, low: low_man, avg: avg_man } = manualData[i];
      const { high: high_ext, low: low_ext, avg: avg_ext } = externalData[i];
      const { high: high_d, low: low_d, avg: avg_d } = d;
      let high = high_man && high_d ? (+high_man > +high_d ? high_man : high_d) : high_d || high_man;
      let low = low_man && low_d ? (+low_man < +low_d ? low_man : low_d) : low_d || low_man;
      let color = +high_man ? MANUAL_COLOR : DEVICE_COLOR;
      if(high_ext && +high_ext > +high) {
        high = high_ext
        color = EXTERNALL_COLOR
      }
      if( low_ext && (!low || +low_ext < +low) ) low = low_ext
      const avg = !!avg_man ^ !!avg_d || avg_man || avg_d || avg_ext ? Math.round((+avg_man + +avg_d + +avg_ext) / (+!!avg_man + +!!avg_d + +!!avg_ext)) : null;
      const empty = !avg;
      return { date, high, low, open: low, close: high, avg, color, empty};
    });

  const x = d3
    .scaleBand()
    .domain(d3.utcDay.range(data[0].date, +data[data.length - 1].date + 1))
    .range([margin.left, width - margin.right])
    .padding(0.4);

  const y = d3
    .scaleLinear()
    .domain([MIN_SPO2_percent, MAX_SPO2_percent])
    .nice()
    .range([height - margin.bottom, margin.top]);
  
  const xAxis = (g) =>
    g.attr('transform', `translate(0,${height - margin.bottom - 2})`)
      .call(d3.axisBottom(x)
          .tickValues(d3.utcDay.every(1).range(data[0].date, +data[data.length - 1].date + 1))
          .tickFormat((d) =>  moment(d).format('ddd DD'))
          .tickSize(0)
      )
      .call((g) =>
        g.selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('transform', `translate(0,${-height + margin.top + margin.bottom + 3})`)
          .attr('y2', height - margin.top - margin.bottom)
      )
      .call((g) => g.select('.domain').remove());

  const yAxis = (g) =>
    g
      .attr('transform', `translate(${margin.left - 10},0)`)
      .call(d3
          .axisLeft(y)
          .tickValues(d3.scaleLinear().domain(y.domain()).ticks())
          .tickSize(0)
          .tickPadding(10)
      )
      .call((g) =>
          g.selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('x2', width - margin.left - margin.right)
      )
      .call((g) => g.select('.domain').remove());

  const oxygenLineGenerate = d3
    .line()
    .defined((d) =>  !(d.open === null && d.close === null))
    .x((d) => x(d.date))
    .y((d) => y(d.avg));

  const svg = d3
    .create('svg')
    .attr('width', width)
    .attr('height', height);
if(thresholdsStatus ==='on'){
  const oxygenLowBackgroundColor = svg
    .append('rect')
    .attr('x', x(data[0].date))
    .attr('y', y(spo2_threshold.low))
    .attr('width', Math.abs(x(data[x.domain().length - 1].date) - x(data[0].date)) + x.bandwidth())
    .attr('height', Math.abs(y(spo2_threshold.low) - y(MIN_SPO2_percent)))
    .attr('fill', LOW_OXYGEN_COLOR)
    .attr('opacity', 1);

  const oxygenHighBackgroundColor = svg
    .append('rect')
    .attr('x', x(data[0].date))
    .attr('y', y(spo2_threshold.high))
    .attr('width', Math.abs(x(data[x.domain().length - 1].date) - x(data[0].date)) + x.bandwidth())
    .attr('height', Math.abs(y(spo2_threshold.high) - y(spo2_threshold.low)))
    .attr('fill', NORMAL_OXYGEN_COLOR)
    .attr('opacity', 1);
}

  const oxygenLine = svg
    .append('path')
    .attr('d', oxygenLineGenerate(data))
    .attr('fill', 'none')
    .attr('transform', (d) => `translate(10,0)`)
    .attr('stroke', 'black');

  svg.append('g').call(xAxis).selectAll('.tick text').call(wrap, x.bandwidth());

  svg.append('g').call(yAxis);

  const yAxisLabelDate = svg
    .append('text')
    .attr('x', margin.left - 40)
    .attr('y', margin.top - 20)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('%');

  const xAxisLabelDate = svg
    .append('text')
    .attr('x', 20)
    .attr('y', height - margin.bottom + 20)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('Date');

  const xAxisLabelDay = svg
    .append('text')
    .attr('x', 20)
    .attr('y', height - margin.bottom + 33)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('Day')
    .style("cursor", "pointer")
    .on("click", (e, d) => onClick(d.date));

  const fixLabelXPosition = width / data.length / 3.7
  const g = svg
    .append('g')
    .selectAll('g')
    .data(data)
    .join('g')
    .attr('transform', (d) => `translate(${x(d.date) + fixLabelXPosition},0)`);
    // .attr('transform', (d) => `translate(${x(d.date) + 11},0)`);

  const emptyGroup = g.append('g').attr('visibility', (d) => {
    return d.empty ? 'visible' : 'hidden';
  });

  const emptyBar = emptyGroup
    .append('line')
    .attr('y1', (d) => y(MIN_SPO2_percent))
    .attr('y2', (d) => y(MAX_SPO2_percent))
    .attr('stroke-width', 35)
    .attr('stroke', (d) => EMPTY_COLOR)
    .attr('opacity', 0.07);

  const oxygenCandleGroup = g.append('g').attr('visibility', (d) => {
    return !(d.open === null && d.close === null) ? 'visible' : 'hidden';
  });
  const oxygenCandle = oxygenCandleGroup
    .append('line')
    .attr('y1', (d) => {
      return y(d.open);
    })
    .attr('y2', (d) => y(d.close))
    .attr('stroke-width', 12)
    .attr('stroke', (d) => d.color);

  const oxygenCircle = oxygenCandleGroup
    .append('circle')
    .attr('r', 10)
    .attr('cy', (d) => y(d.avg))
    .attr('stroke-width', 1)
    .attr('fill', 'white')
    .attr('stroke', (d) => d.color)
    .style("cursor", "pointer")
    .on("click", (e, d) => onClick(d.date));

  const oxygenCircleText = oxygenCandleGroup
    .append('text')
    .attr('text-anchor', 'middle')
    .attr('dy', (d) => y(d.avg) + 5)
    .style('font-size', '11px')
    .attr('font-weight', '400')
    .append('tspan')
    .attr('font-family', 'roboto')
    .text((d) => d.avg)
    .style("cursor", "pointer")
    .on("click", (e, d) => onClick(d.date));

  const gLegend = svg.append('g').attr('transform', (d) => `translate(${width-550},${margin.top - 15})`);
  const oxygenLegendRect = gLegend
    .append('rect')
    .attr('x', 130)
    .attr('y', 0)
    .attr('width', 10)
    .attr('height', 10)
    .attr('fill', DEVICE_COLOR);
  const oxygenDeviceText = gLegend
    .append('text')
    .attr('x', 145)
    .attr('y', 9)
    .style('font-size', '17px')
    .attr('font-weight', '100')
    .text('Device measurements');

  const oxygenManualLegendRect = gLegend
    .append('rect')
    .attr('x', -70)
    .attr('y', 0)
    .attr('width', 10)
    .attr('height', 10)
    .attr('fill', MANUAL_COLOR);

  const oxygenManualLegendText = gLegend
    .append('text')
    .attr('x', -50)
    .attr('y', 9)
    .style('font-size', '17px')
    .attr('font-weight', '100')
    .text('Manual measurements');

  const oxygenExternalLegendRect = gLegend
    .append('rect')
    .attr('x', 320)
    .attr('y', 0)
    .attr('width', 10)
    .attr('height', 10)
    .attr('fill', EXTERNALL_COLOR);

  const oxygenExternalLegendText = gLegend
    .append('text')
    .attr('x', 340)
    .attr('y', 9)
    .style('font-size', '17px')
    .attr('font-weight', '100')
    .text('External measurements');

  const oxygenLegendAverageCircle = gLegend
    .append('circle')
    .attr('cx', -200)
    .attr('cy', 3)
    .attr('r', 7)
    .attr('stroke-width', 1)
    .attr('fill', 'white')
    .attr('stroke', '#4AA5D4');

  const oxygenLegendAverageText = gLegend
    .append('text')
    .attr('x', -205)
    .attr('y', 9)
    .style('font-size', '17px')
    .attr('font-weight', '100')
    .text('#\u00A0\u00A0Average SpO2');
  const missingValuesLegendRect = gLegend
    .append('rect')
    .attr('x', -380)
    .attr('y', 0)
    .attr('width', 10)
    .attr('height', 10)
    .attr('opacity', 0.11)
    .attr('fill', '#000000');

  const missingValuesLegendText = gLegend
    .append('text')
    .attr('x', -360)
    .attr('y', 9)
    .style('font-size', '17px')
    .attr('font-weight', '100')
    .text('No measurements');

  return svg.node();
};

